import React, { useState, useEffect } from 'react';
import { StyledText } from "../../../../components/common/basic";

const getTwoDigitValue = value => {
  if (value < 10) {
    return '0' + value;
  }
  return '' + value;
}

const CountdownTimer = ({ timeRemaining, startTime, background, seconds, showBottomText = true, onHandleIsTime }) => {
  const [day, setDays] = useState('--');
  const [hour, setHours] = useState('--');
  const [minute, setMinutes] = useState('--');
  const [second, setSeconds] = useState('--');
  const [isTime, setIsTime] = useState(false);

  const calculateTime = () => {
    let timeElapsed = (new Date()).getTime() - startTime

    let seconds = (timeRemaining - timeElapsed) / 1000;

    if (seconds < 1) {
      setIsTime(true)
      onHandleIsTime(true)
      return;
    }

    let days = Math.floor(seconds / (24 * 60 * 60)); // 1 day is equal to 24 hours, each hour has 60 mins and 60 seconds
    seconds -= days * 24 * 60 * 60; // Get remaining seconds

    let hours = Math.floor(seconds / (60 * 60)); // 1 hour has 60 mins and 60 seconds
    seconds -= hours * 60 * 60; // Get remaining seconds

    let minutes = Math.floor(seconds / 60); // 1 minute is equal to 60 seconds
    seconds -= minutes * 60; // Get remaining seconds

    days = Math.abs(days);
    hours = Math.abs(hours);
    minutes = Math.abs(minutes);
    seconds = Math.floor(Math.abs(seconds));
    setDays(getTwoDigitValue(days));
    setHours(getTwoDigitValue(hours));
    setMinutes(getTwoDigitValue(minutes));
    setSeconds(getTwoDigitValue(seconds));
    startTimer();
  }

  const startTimer = () => {
    setTimeout(calculateTime, 1000)
  }

  useEffect(() => {
    if (timeRemaining) {
      calculateTime();
      startTimer();}
  }, [timeRemaining]);

  return (
    <div style={{
      padding: '12px 15px 20px 15px',
      background,
      textAlign: 'center'
    }}>
      {
        isTime ?
          <StyledText size={18} style={{ fontFamily: 'MTNMedium' }} color="#fff">Redeem Rewards 🎉</StyledText>
          :
          <>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                alignItems: 'center',
                margin: '0 auto 28px auto',
                maxWidth: '250px',
                fontFamily: 'Digital Numbers Regular',
                fontSize: '29px',
                width:400,
                color: '#fff'
              }}>
              <>
                <TimerUnit value={day} label="DAYS" />
                <div>:</div>
                <TimerUnit value={hour} label="HOURS" />
                <div>:</div>
                <TimerUnit value={minute} label="MINS" />
                <div>:</div>
                <TimerUnit value={second} label="SECS" />
              </>
            </div>
            {showBottomText&&<StyledText size={18} style={{ fontFamily: 'MTNMedium' }} color="#fff">To Redeem Rewards 🎉</StyledText>}
          </>
      }
    </div>
  )
}

const TimerUnit = ({ value, label }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', }}>
      <div style={{ position: 'relative' }}>
        <div>{value}</div>
        <StyledText
          size={9}
          style={{
            position: 'absolute',
            fontFamily: 'MTNRegular, sans-serif',
            margin: '0 auto',
            left: 0,
            right: 0,
            top: '40px'
          }}
          color={'#fff'}>
          {label}
        </StyledText>
      </div>
    </div>
  )
}

export default CountdownTimer;